import type { Customer } from '@ctct/domain-layer';
import { observabilityAppService } from '@ctct/myaccount-utils-static';
import type { UsePartnerPromoCodesParamStoreReturn } from '@ctct/state-server-layer';

// if you make changes here -- update the documentation
// https://ctct.atlassian.net/wiki/spaces/ProdDel/pages/13844971629/How+to+auto-apply+a+promo+code+for+partners+on+Payflow
export class PartnerPromoCodeService {
  private readonly AU = 'AU';

  private readonly NZ = 'NZ';

  private readonly US = 'US';

  private readonly UK = 'UK';

  private readonly REST = 'REST';

  constructor(
    private partnerIdToPromoCode: ReturnType<UsePartnerPromoCodesParamStoreReturn['getPartnerIdToPromoCode']>,
    private customer?: Customer
  ) {}

  public getPromoCodeForPartner(): string | undefined {
    if (!this.customer) return undefined;

    const partnerId = this.customer.getPartnerId();

    if (!partnerId) return undefined;

    let promoCode = this.partnerIdToPromoCode[partnerId];

    if (typeof promoCode === 'object') {
      const auPromoCode = promoCode[this.AU];
      const nzPromoCode = promoCode[this.NZ];
      const usPromoCode = promoCode[this.US];
      const ukPromoCode = promoCode[this.UK];

      if (auPromoCode && this.customer.isAu()) {
        promoCode = auPromoCode;
      } else if (nzPromoCode && this.customer.isNz()) {
        promoCode = nzPromoCode;
      } else if (usPromoCode && this.customer.isUs()) {
        promoCode = usPromoCode;
      } else if (ukPromoCode && this.customer.isUk()) {
        promoCode = ukPromoCode;
      }

      const promoCodeForTheRest = promoCode[this.REST];
      const promoCodeWasNotAppliedForAnyCountry = typeof promoCode === 'object';

      if (promoCodeForTheRest && promoCodeWasNotAppliedForAnyCountry) {
        promoCode = promoCodeForTheRest;
      }
    }

    if (typeof promoCode !== 'string' && promoCode !== undefined) {
      observabilityAppService.notify(new Error('Invalid partner promo code from statsig'), { promoCode, partnerId });
    } else {
      return promoCode;
    }

    return undefined;
  }
}
